import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AuthBackground from '../../components/AuthBackground';
import ScreenContainer from '../../components/ScreenContainer';
import TopBar from '../../components/TopBar';
import Heading from '../../components/Heading';
import Text from '../../components/Text';
import OTPInput from '../../components/OTPInput';
import Button from '../../components/Button';
import LinkButton from '../../components/LinkButton';
import Toast from '../../components/Toast';
import api from '../../api';

const VerifyCode = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || '';
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [resending, setResending] = useState(false);
  const [toast, setToast] = useState(null);
  
  const maskedEmail = email.replace(/^(.{2}).*(@.*)$/, '$1****$2');

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await api.post('/accounts/auth/verify-otp/', {
        email,
        code: otp
      });
      
      if (response.data.success) {
        setToast({ type: 'success', message: 'OTP verified!' });
        setTimeout(() => {
          navigate('/auth/new-password', { state: { email } });
        }, 1500);
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Invalid OTP. Please try again.';
      setToast({ type: 'error', message: errorMessage });
    } finally {
      setLoading(false);
    }
  };

  const handleResend = async () => {
    setResending(true);
    try {
      const response = await api.post('/accounts/auth/send-otp/', { email });
      
      if (response.data.success) {
        setToast({ type: 'success', message: 'New OTP sent to your email!' });
        setOtp('');
      }
    } catch (error) {
      const errorMessage = error.response?.data?.error || 'Failed to resend OTP.';
      setToast({ type: 'error', message: errorMessage });
    } finally {
      setResending(false);
    }
  };

  return (
    <>
      <AuthBackground />
      <ScreenContainer>
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <TopBar 
            title="Check Your Email" 
            onBack={() => navigate('/auth/forgot-password')}
          />
          <div className="mb-6">
            <Heading size="lg" className="mb-3">Verify Code</Heading>
            <Text>We sent a reset code to {maskedEmail}. Enter the 6 digit code mentioned in the email.</Text>
          </div>
          <div className="space-y-6">
            <OTPInput
              value={otp}
              onChange={setOtp}
              length={6}
            />
            <Button 
              fullWidth
              onClick={handleSubmit}
              loading={loading}
              disabled={otp.length !== 6}
            >
              Verify Code
            </Button>
            <div className="text-center">
              <Text variant="small">Didn't receive the email?</Text>
              <LinkButton onClick={handleResend} className="mt-2" disabled={resending}>
                {resending ? 'Sending...' : 'Resend email'}
              </LinkButton>
            </div>
          </div>
        </div>
      </ScreenContainer>
      <Toast 
        message={toast?.message} 
        type={toast?.type}
        onClose={() => setToast(null)}
      />
    </>
  );
};

export default VerifyCode;